<template>
  <b-card>
    <div slot="header">{{ $lang.add_daily_working }}</div>
    <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
    <DailyWorkingForm v-show="!loading" @submit="save" @close="close" />
  </b-card>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import DailyWorkingForm from "./forms/dailyWorkingForm.vue";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    DailyWorkingForm,
    LoadingSpinner,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    pathOr,
    close() {
      this.$emit("close");
    },
    async save(getPayload) {
      try {
        this.loading = true;
        const url = generateApiUrl(["cooperation", "daily_working"]);
        const {
          enter_time,
          exit_time,
          end_time,
          description,
          working_amount,
          order_unit_id,
          factor,
          ...payload
        } = getPayload;
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.close();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
